import React from 'react';
import { ArrowRight } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  href = 'https://tulibrodigital.lat/cart/add?id=50125183484128&quantity=1',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold rounded-xl transition-all duration-300 transform hover:-translate-y-0.5 overflow-hidden group';
  const variants = {
    primary: 'bg-gold hover:bg-yellow-500 text-forest-green shadow-lg hover:shadow-glow-lg px-6 py-4 md:py-5 text-lg md:text-xl animate-pulse-glow',
    secondary: 'bg-forest-green hover:bg-green-accent text-white shadow-md px-5 py-3 text-base'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
  };
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-314">
        {children}
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-315" />
      </span>
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent z-0" data-id="element-316" />
    </>;
  if (href) {
    return <a href={href} onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} data-id="element-317">
        {content}
      </a>;
  }
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={e => {
    handleClick();
    props.onClick?.(e);
  }} {...props} data-id="element-318">
      {content}
    </button>;
}